import _Reflect$construct from "@babel/runtime-corejs3/core-js-stable/reflect/construct";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _inherits from "@babel/runtime-corejs3/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { autobind } from 'core-decorators';
import invariant from 'invariant';
import { match } from '@rexlabs/whereabouts';
import { withWhereabouts } from './connectors';
var Match = (_dec = withWhereabouts(), _dec(_class = autobind(_class = (_temp = _class2 = /*#__PURE__*/function (_PureComponent) {
  _inherits(Match, _PureComponent);

  var _super = _createSuper(Match);

  function Match() {
    _classCallCheck(this, Match);

    return _super.apply(this, arguments);
  }

  _createClass(Match, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          location = _this$props.location,
          route = _this$props.route,
          pattern = _this$props.pattern,
          whereabouts = _this$props.whereabouts,
          children = _this$props.children,
          exact = _this$props.exact;
      invariant(route || pattern, "You have to define either 'route' or 'pattern' prop in '<Match />'!");
      var matchLocation = location || whereabouts;
      var matched = null;

      if (route) {
        invariant(route.config, "Invalid 'route' prop has been passed into '<Match />'! No config node found!");
        matched = match(matchLocation, route.config, {
          exact: exact
        });
      } else {
        matched = match(matchLocation, {
          path: pattern
        }, {
          exact: exact
        });
      }

      if (typeof children === 'function') {
        return children(matched);
      } else if (matched) {
        return children;
      } else {
        return null;
      }
    }
  }]);

  return Match;
}(PureComponent), _defineProperty(_class2, "propTypes", {
  exact: PropTypes.bool,
  route: PropTypes.object,
  // Only to make pattern matching easier, can also be achieved by
  // passing in the pattern as a route!
  pattern: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(RegExp)]),
  // Optional location, if not defined <Match /> will use current location
  // from whereabouts state instead
  location: PropTypes.object,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.func])
}), _temp)) || _class) || _class);
export default Match;